import { ManagementFrameRoot, ManagementFrameToolbar, ManagementFrameDesktop, ManagementFrameMobile, ManagementFrameState, ManagementFramePagination } from './management-frame-primitives';

const ManagementFrame = {
  Desktop: ManagementFrameDesktop,
  Mobile: ManagementFrameMobile,
  Pagination: ManagementFramePagination,
  Root: ManagementFrameRoot,
  State: ManagementFrameState,
  Toolbar: ManagementFrameToolbar,
} as const;

export { ManagementFrame };
